import type { AccountTriggerMeta } from "./types.ts";

type AccountTriggerProps = {
  meta: AccountTriggerMeta;
  open: boolean;
  onToggle: () => void;
};

export function AccountTrigger({ meta, open, onToggle }: AccountTriggerProps) {
  return (
    <button
      type="button"
      className={`account-switcher-trigger ${open ? "is-open" : ""}`}
      onClick={onToggle}
    >
      <span className="account-switcher-badge" style={{ background: meta.badgeColor }}>{meta.badge}</span>
      <span className="account-switcher-label">{meta.label}</span>
      <span className="account-switcher-caret">{"\u25be"}</span>
    </button>
  );
}
